/** A real capture of the product, presented in a minimal browser frame.
 *  These are actual screenshots of the running app (seeded sample data) —
 *  not illustrations. Capture provenance is logged in
 *  docs/loops/landing-page/CONTENT_MAP.md. */
type Props = {
  src: string;
  alt: string;
  /** Pill label; defaults to the honest provenance statement. */
  label?: string;
  /** URL shown in the chrome bar (cosmetic). */
  url?: string;
  /** Crop tall captures to a fixed-height "window" (density pass) — pick which
   *  edge of the capture stays visible. */
  window?: "top" | "bottom";
};

export function ProductShot({ src, alt, label = "Real product · sample data", url = "app.firmark.dev", window: win }: Props) {
  return (
    <figure className={`pshot${win ? ` pshot--window pshot--window-${win}` : ""}`}>
      <div className="pshot-chrome" aria-hidden="true">
        <span className="pshot-dots"><i /><i /><i /></span>
        <span className="pshot-url shot-mono">{url}</span>
        <span className="pshot-pill">{label}</span>
      </div>
      <img className="pshot-img" src={src} alt={alt} loading="lazy" decoding="async" />
    </figure>
  );
}
